module.exports = __webpack_public_path__ + "img/platform_unas.aa2b1763.svg";